import { useTranslation } from '@/app/_shared/hooks/useTranslation';
import { LikeIcon } from '@/components/common/Icons';
import { SvgLikeFill } from '@/components/common/Icons/LikeFill';
import type { CommentActionsProps } from '@/features/comments/types';
import { getTimeFromNow } from '@/features/comments/utils';

export const CommentActions = ({
	onLike,
	onReply,
	likes,
	isLiked,
	createdAt,
}: CommentActionsProps) => {
	const { t } = useTranslation();
	return (
		<div className="flex items-center gap-4 mt-[6px] text-[13px]">
			<span className="text-[#8F8F8F]">{getTimeFromNow(createdAt)}</span>
			<button
				type="button"
				onClick={() => onLike({ reactionType: isLiked ? null : 'LIKE' })}
				className="flex items-center gap-1.5 text-[#8F8F8F] hover:text-green-600 cursor-pointer"
			>
				{isLiked ? <SvgLikeFill width={14} height={14} /> : <LikeIcon />}
				<span>{likes}</span>
			</button>
			<button
				type="button"
				onClick={onReply}
				className="text-[#8F8F8F] hover:text-green-600 cursor-pointer"
			>
				{t('common:reply')}
			</button>
		</div>
	);
};
